module.exports = __webpack_public_path__ + "static/media/015-dentist.7f07d80a.svg";